import React, { Component } from 'react'
import './home.css'
import NavArr from '../handf/nav.json'
import Footer from '../handf/Footer'
import PopUp from '../round/PopUp'
import { post } from '../../ajax/tools'

// 阿拉伯数字转大写
// let Num = function (num) {
//     if (num === 10) {
//         return '十'
//     } else if (num === 1) {
//         return '一'
//     }
//     const digits = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
//     const units = ['', '十', '百', '千', '万'];
//     let result = '';
//     let numStr = num.toString();
//     for (let i = 0; i < numStr.length; i++) {
//         let digit = parseInt(numStr.charAt(i));
//         let unit = units[numStr.length - i - 1];
//         if (digit === 0) {
//             // 当前数字为0时不需要输出汉字，但需要考虑上一个数字是否为0，避免出现连续的零
//             if (result.charAt(result.length - 1) !== '零') {
//                 result += '零';
//             }
//         } else {
//             result += digits[digit] + unit;
//         }
//     }
//     // 对于一些特殊的数字，如10、100等，需要在最前面加上“一”
//     if (result.charAt(0) === '一') {
//         result = result.substring(1, result.length);
//     } else if (result.charAt(0) === '百') {
//         result = '一' + result;
//     } else if (result.charAt(0) === '千') {
//         result = '一' + result;
//     }
//     return result;
// };

class WM extends Component {
  constructor(props) {
    super(props)
    this.state = {
      YJPage: 0,

      PersonArr: [
        {
          id: 1,
          name: '特邀嘉宾',
          url: 'http://oss.asfcyy.com/richTextImage/e5f307bae29111ee9dc800163e3521a2.jpg',
          style: {},
        },
        {
          id: 2,
          name: '裁判员',
          url: 'http://oss.asfcyy.com/richTextImage/f0e222dce29111ee9dc800163e3521a2.jpg',
          style: {},
        },
        {
          id: 3,
          name: '教练员',
          url: 'http://oss.asfcyy.com/richTextImage/00e3ff98e29211ee9dc800163e3521a2.jpg',
          style: {},
        },
        {
          id: 4,
          name: '运动员',
          url: 'http://oss.asfcyy.com/richTextImage/0cbaf042e29211ee9dc800163e3521a2.jpg',
          style: { position: 'absolute', left: '-6.2%' },
        },
      ],

      CityArr: [],
      CityInfo: {},
      City: '',
      CityId: '',
      Year: '',
    }
  }
  componentDidMount = function () {
    let date = new Date()
    let ToDayYear = date.getFullYear()
    post({
      url: 'match/show_jbs_pro',
      data: {
        match_year: ToDayYear,
        match_type: 1,
      },
    }).then((res) => {
      if (res.errno === '200' && res.data.length !== 0) {
        this.setState({
          CityArr: res.data,
          Year: ToDayYear,
          City: res.data[0].province,
          CityId: res.data[0].id,
          CityInfo: res.data[0],
        })
      } else {
        post({
          url: 'match/show_jbs_pro',
          data: {
            match_year: ToDayYear - 1,
            match_type: 1,
          },
        }).then((res) => {
          if (res.errno === '200' && res.data.length !== 0) {
            this.setState({
              CityArr: res.data,
              Year: ToDayYear - 1,
              City: res.data[0].province,
              CityId: res.data[0].id,
              CityInfo: res.data[0],
            })
          } else {
            this.setState({
              CityArr: [],
              Year: ToDayYear - 1,
              City: '',
              CityId: '',
              CityInfo: {},
            })
          }
        })
      }
    })
  }

  componentWillUnmount = () => {
    this.setState = (state, callback) => {}
  }

  NavListClick = (item, index) => {
    const { history } = this.props
    history.push(item.router)
    this.setState({
      YJPage: 0,
    })
  }

  LXFSCityClick = (item, index) => {
    this.setState({
      CityInfo: item,
      CityId: item.id,
    })
  }

  JoinGame() {
    window.open('https://www.asfcyy.net/match')
  }

  //
  //
  // BackTop=()=>{
  //     window.scrollTo({
  //         left: 0,
  //         top: 0,
  //         behavior: 'smooth',
  //     });
  // };

  //提示弹窗
  ChildBackTip = (event) => {
    if (event === 'CrossOut') {
      this.setState({
        PopUp: '',
      })
    }
  }

  render() {
    return (
      <div className={'Home'}>
        {/*背景*/}
        <div className={'WMColor'}>
          <img
            className={'WMBg'}
            src="http://oss.asfcyy.com/richTextImage/8d49bb86e17211f09dcd00163e3521a2.jpg"
            alt=""
          />
          <div></div>
          {/*菜单*/}
          <div className={'HomeNavTopBox'} style={{ position: 'relative' }}>
            <div className={'NavTopBox'}>
              <div className={'HomeLogoBox'}>
                <img
                  className={'HomeLogo'}
                  src="http://oss.asfcyy.com/richTextImage/616aeb76dee911ee9dc800163e3521a2.png"
                  alt=""
                />
              </div>
              <div className={'NavTop clearfix'}>
                {NavArr.map((item, index) => (
                  <div
                    className={'NavTopList'}
                    key={index}
                    onClick={() => this.NavListClick(item, index)}
                  >
                    {item.name}
                  </div>
                ))}
              </div>
            </div>
          </div>
          {this.state.Year !== '' && (
            <div>
              <div className={'WMTit'}>
                {new Date().getFullYear() - 1} - {new Date().getFullYear()}
                学年全国青少年模拟飞行锦标赛
              </div>
              {/*<div className={'WMTit'}>第{Num(this.state.Year-2009)}届全国青少年模拟飞行锦标赛</div>*/}
              <div className={'WMBtn'} onClick={this.JoinGame.bind(this)}>
                我要报名
              </div>
            </div>
          )}
        </div>

        {/*参赛要求*/}
        <div className={'CSYQ'}>
          <div className={'YJBox'}>
            <div className={'CSYQImgBox'}>
              {/*<img src="http://oss.asfcyy.com/richTextImage/c2b3c7bae15311ee9dc800163e3521a2.jpg" alt=""/>*/}
              {/*<img src="http://oss.asfcyy.com/richTextImage/352bd042e29b11ee9dc800163e3521a2.jpg" alt=""/>*/}
              <img
                src="http://oss.asfcyy.com/richTextImage/7f0c9140e17911f09dcd00163e3521a2.png"
                alt=""
              />
            </div>
            <div className={'CSYQWordBox'}>
              <div className={'YJWordTit'}>参赛要求</div>
              <div className={'YJWordBor'}> </div>
              <div className={'YJWord3'}>
                依据最新公布的《中国航空运动协会官方全国性模拟飞行竞赛规则》中内容及科目要求开展学习、训练。
              </div>
              <div className={'YJWord3'}>
                遵守《体育总局航管中心赛风赛纪管理规定》。
              </div>
              <div className={'YJWord3'}>
                按照体育总局航管中心关于“全国青少年模拟飞行锦标赛”最新相关通知、规程参赛。
              </div>
              <div className={'YJWord3'}>
                全国在校中小学生持学籍卡均可报名参赛。
              </div>
            </div>
          </div>
        </div>
        <div className={'CSYQ'}>
          <div className={'YJBox'}>
            <div className={'CSYQImgBox'} style={{ right: 0, left: 'unset' }}>
              {/*<img src="http://oss.asfcyy.com/richTextImage/fb97e444e15311ee9dc800163e3521a2.jpg" alt=""/>*/}
              {/*<img src="http://oss.asfcyy.com/richTextImage/228944e2e29b11ee9dc800163e3521a2.jpg" alt=""/>*/}
              <img
                src="http://oss.asfcyy.com/richTextImage/352bd042e29b11ee9dc800163e3521a2.jpg"
                alt=""
              />
            </div>
            <div className={'CSYQWordBox'} style={{ left: 0, right: 'unset' }}>
              <div className={'YJWordTit'}>参赛流程</div>
              <div className={'YJWordBor'}> </div>
              <div className={'YJWord3'}>
                全国青少年模拟飞行锦标赛分为全国总决赛和省选拔赛，采取自下而上、逐级选拔的方式开展。参赛者需要先参加省选拔赛，成绩优秀者获得参加全国总决赛竞赛资格。
              </div>
              <div className={'YJWord3'}>各省根据通知开展省选拔赛。</div>
              <div className={'YJWord3'}>
                各省按照本赛事竞赛规程、规则和竞赛有关事项的通知、补充通知要求，组队参加全国总决赛。
              </div>
              <div className={'YJWord3'}>
                各级别竞赛结束公布成绩册后，由各级赛事组织单位现场颁发奖牌、奖杯、证书，或由赛事组织单位统一邮寄给获奖者。
              </div>
            </div>
          </div>
        </div>

        {/*人员组成*/}
        <div className={'RYZC'}>
          <div className={'PersonTit'}>人员组成</div>
          <div className={'CDTBox'}>
            {this.state.PersonArr.map((item, index) => (
              <div className={'RYZCBoxListBox'} key={index}>
                <div className={'RYZCBoxListImg'}>
                  <img src={item.url} alt="" style={item.style} />
                </div>
                <div className={'RYZCBoxListBtn'}>{item.name}</div>
              </div>
            ))}
          </div>
        </div>

        {/*联系方式*/}
        <div className={'LXFSBox'}>
          <div className={'LXFSMain'}>
            <div className={'LXFSMainTit'}>赛事官方联系方式</div>
            <div className={'LXFSMainWord'}>
              {this.state.Year !== '' && (
                <div>
                  如果您对“全国青少年模拟飞行锦标赛”的省赛及总决赛有任何疑问、建议、意见，请发送到下列邮箱中，我们将尽快给您反馈。
                </div>
              )}
            </div>
            {/*<div className={'LXFSMainWord'}>如果您对“{this.state.Year}年全国青少年模拟飞行锦标赛”的省赛及总决赛有任何疑问、建议、意见，请发送到下列邮箱中，我们将尽快给您反馈。</div>*/}
            <div className={'LXFSMainWord'}>总决赛：qsp@asfcyy.com</div>
            <div className={'LXFSMainCityBox clearfix'}>
              <div className={'LXFSMainCityList'}>
                {this.state.CityArr.map((item, index) => (
                  <div
                    className={'LXFSMainCity'}
                    key={index}
                    onClick={() => this.LXFSCityClick(item, index)}
                    style={
                      this.state.CityId === item.id
                        ? { borderLeft: '8px solid #FD7521' }
                        : {}
                    }
                  >
                    {item.province}
                  </div>
                ))}
              </div>
              {this.state.CityArr.length !== 0 && (
                <div className={'LXFSMainBox'}>
                  <div className={'LXFSInfo'}>
                    赛区联系人：{this.state.CityInfo.district_contact}
                  </div>
                  <div className={'LXFSInfo'}>
                    联系电话： {this.state.CityInfo.mobile}
                  </div>
                  <div className={'LXFSInfo'}>
                    邮箱：{this.state.CityInfo.email}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <Footer />
        {this.state.PopUp === '提示弹窗' && (
          <PopUp
            ChildBackClick={this.ChildBackTip.bind(this)}
            type={'提示'}
            message={this.state.MessageTip}
            OutButton={'Yes'}
          />
        )}
      </div>
    )
  }
}

export default WM
